import { DerivedDataObject, Filter } from 'react-table';

export const filterRowsAndPivotsThroughSelect = (filter: Filter, row: DerivedDataObject) => {
  if (row._subRows === undefined) {
    return row[filter.id].toLowerCase() === filter.value.toLowerCase();
  } else {
    return true;
  }
};
